import React from 'react';
import { twMerge } from 'tailwind-merge';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';

interface Props {
    onClick: (e: React.MouseEvent) => void;
    disabled: boolean;
    iconKey: IconKey;
    label: string;
    className: string;
}

const ButtonBase = ({
    onClick,
    disabled,
    iconKey,
    label,
    className,
}: Props) => (
    <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={twMerge(
            'flex h-10 items-center gap-1 rounded px-3 text-xs font-bold antialiased transition-colors disabled:pointer-events-none disabled:opacity-50',
            className,
        )}
    >
        <Icon iconKey={iconKey} size="1.5rem" />
        {label}
    </button>
);

export default ButtonBase;
